import { Component, OnInit } from '@angular/core';
import { FormBuilder,FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';

declare var jQuery: any;
@Component({
  selector: 'app-admins',
  templateUrl: './admins.component.html',
  styleUrls: ['./admins.component.scss']
})
export class AdminsComponent implements OnInit {
  adminList: any = [];
  user: any
  updateClient = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    mobileNo: new FormControl('', [Validators.required]),
    email: new FormControl('',  [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
    locationId: new FormControl('', [Validators.required]),
    username: new FormControl('', [Validators.required]),
    password: new FormControl(''),
    id: new FormControl(''),
    userOption:new FormControl('')
  });

  constructor(private formBuilder: FormBuilder, private router: Router, private appointmentService: AppointmentService, private spinner: NgxSpinnerService) { }
  location: any = null
  userType = 1003;
  userForm!: FormGroup;
  openModal: boolean = false;
  confPass: string = '';
  userOption: boolean = false;
  buttonText: any = "Edit"
  successMessage: string = '';





  ngOnInit(): void {
    this.spinner.show();
    const successMessage = localStorage.getItem('successMessage');
    if (successMessage) {
      this.successMessage = successMessage;
      localStorage.removeItem('successMessage');
  
      setTimeout(() => {
        this.successMessage = '';
      }, 3000);
    }
    this.appointmentService
      .getUserAll(this.location, this.userType)
      .subscribe((res) => {
        this.adminList = res.data;
        this.spinner.hide();

      });
  }

  createDiag() {
    this.router.navigate(
      ['/create-admin']
    );
    // this.router.navigateByUrl('/create-user', { state: {user:"diagnostician"} });

  }

  editForm() {
    if (this.buttonText == "Edit") {
      this.buttonText = "Save";
      this.userForm.enable()
    }

    else {
      this.buttonText = "Edit";
      this.userForm.disable()
    }
  }
  updateClientMethod(user:any) {
    this.userOption=user.userOption;
    this.updateClient.setValue({
      firstName: user.firstName,
      lastName: user.lastName,
      mobileNo: user.mobileNo,
      email: user.email,
      locationId: user.locationId,
      username: user.username,
      password: '',
      id: user.id,
      userOption:!user.userOption
    });

  }
  get f() { return this.updateClient.controls; }
  onClickSubmit(){
    this.spinner.show();
    console.log("server");
    this.appointmentService
      .updateUser(this.updateClient.value).subscribe(res => {
        localStorage.setItem('successMessage', 'Admin details updated successfully.');
        jQuery("#editDiaInfo").modal('hide');
        this.pageReload();
        this.spinner.hide();
      }, err => {
        // Handle error scenario
        this.successMessage = 'Error updating director details.';
        this.spinner.hide();
      }
      );

    this.spinner.hide();

  }
  pageReload() {
    location.reload()
  }

  getUser(user: any) {
    this.user = user
   
    this.userForm = this.formBuilder.group({
      locationId: [this.user.location, Validators.required],
      username: [this.user.username],
      firstName: [this.user.firstName, Validators.required],
      lastName: [this.user.lastName, Validators.required],
      password: ['', Validators.required],
      mobileNo: [this.user.mobileNo, Validators.required],
      email: [this.user.email, Validators.required],
      role: [this.user.role,],
    });

    this.userForm.disable();
    this.openModal = true


  }


}
